module.exports = __webpack_public_path__ + "static/media/after.bc8b0f82.png";